export enum EPromoType {
  Bank = 'bank',
  Bonus = 'bonus',
  Discount = 'discount',
  MaternalCapital = 'maternalCapital',
  MilitaryMortgage = 'militaryMortgage',
  CianMortgage = 'cianMortgage',
  Mortgage = 'mortgage',
}

export interface IPromo {
  authorLogoUrl?: string | null;
  authorName?: string | null;
  availableJks: IAvailableJk[];
  bank: IPromoBank | null;
  banks: IPromoBank[];
  companyId: number | null;
  description?: string;
  end?: string;
  features: IPromoFeature[];
  isBlackFriday: boolean;
  isFromBank: boolean;
  isFromBuilder: boolean;
  mortgageParams: IPromoMortgageParams | null;
  name: string;
  promoId: number;
  uniquePromoId: string;
  promoImage?: string;
  promoSource?: string;
  promoType: EPromoType;
  authorRealtyUserId?: number;
  start?: string;
  subtitle?: string;
}

export interface IAvailableJk {
  id: number;
  link: string;
  name: string;
}

export interface IPromoBank {
  cianMortgagePartnerLink?: string;
  id: number;
  isPartner: boolean;
  logoUrl?: string;
  name: string;
  secondRoundImageUrl?: string;
  secondSquareImageUrl?: string;
}

export interface IPromoFeature {
  name: string;
  value: string;
}

export interface IPromoMortgageParams {
  interestRate?: number | null;
  maxCredit?: number | null;
  maxLoanTerm?: number | null;
  minInitialPaymentRate?: number | null;
}
